import { render, staticRenderFns } from "./GroupListPopover.vue?vue&type=template&id=098bdbac&scoped=true"
import script from "./GroupListPopover.vue?vue&type=script&lang=js"
export * from "./GroupListPopover.vue?vue&type=script&lang=js"
import style0 from "./GroupListPopover.vue?vue&type=style&index=0&id=098bdbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bdbac",
  null
  
)

export default component.exports